import React from "react";
import { Box, Typography } from "@mui/material";
import "./LoanSetupDetailsView.scss";

const formatLabel = (key) => {
    return key
      .replace(/([A-Z])/g, " $1")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
};

const yesNoFields = [
    "ignoreholidays",
    "flagging",
    "optout",
    "optin",
    "includefeesineligibilitycheck",
    "restrictive",
    "ignorenextbusinessday",
    "selectablebyuser",
    "isflaggedloandue",
    "displayorderno"
];

const renderSection = (title, data = {}, formName = "", handleLangIdClick) => {
    console.log("data===========",data)
    let entries = Object.entries(data);

    if (entries.length === 0) return null;

    const half = Math.ceil(entries.length / 2);
    const left = entries.slice(0, half);
    const right = entries.slice(half);

    return (
        <Box sx={{ mb: 4 }}>
            <Typography
                sx={{
                    fontWeight: 700,
                    fontSize: "16px",
                    color: "#4B5563",
                    fontFamily: "Nunito",
                    mb: 2,
                    borderBottom: "2px solid #E5E7EB",
                    pb: 1,
                }}
            >
                {title}
            </Typography>

            <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                {[left, right].map((column, index) => (
                    <Box key={index} flex={1}>
                        {column.map(([key, value]) => {
                            let displayValue = value !== "" ? value : "-";
                            // console.log("key--------",key)
                            if (formName === "createloancurrmsg" && key === "latefeecalculationmode") {
                                displayValue = value === "1" ? "Outstanding principle fee latefee" : "Outstanding principle";
                            }

                            return (
                                <Box 
                                    key={key} 
                                    className="info-container" 
                                    onClick={() => {
                                        if (key.endsWith("langid")) {
                                            console.log(`LangID clicked: ${key} = ${displayValue}`);
                                            handleLangIdClick(displayValue);
                                        }
                                    }}
                                >
                                    <Box className="info-type">{formatLabel(key)}:</Box>
                                    <Box className="info-response" sx={key.endsWith("langid") ? { cursor: "pointer", textDecoration: "underline" } : {}}>{displayValue}</Box>
                                </Box>
                            );
                        })}
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

const LoanSetupDetailsView = ({ title = "Info", data = {}, formName = "", handleLangIdClick }) => {
    return (
        <Box className="user-accounts-tab">
            <Typography
                sx={{
                    fontWeight: 800,
                    color: "#6b7280",
                    fontFamily: "Nunito",
                    fontSize: "20px",
                    fontStyle: "normal",
                    mb: 3,
                }}
            >
                {title}
            </Typography>
            {
                renderSection("Details", data, formName, handleLangIdClick)
            }
        </Box>
    );
};

export default LoanSetupDetailsView;
